/** Admin API service (super_admin scope). */
import apiClient from '@/services/api/client';

export async function listMunicipalities(search) {
        const { data } = await apiClient.get('/v1/admin/municipalities', {
                params: search ? { search } : {},
        });
        return data;
}

export async function provisionMunicipality(body) {
        const { data } = await apiClient.post('/v1/admin/municipalities', body);
        return data; // { municipality, admin: { ..., temporary_password } }
}

export async function updateMunicipality(id, body) {
        const { data } = await apiClient.put(`/v1/admin/municipalities/${id}`, body);
        return data;
}
